import { render, staticRenderFns } from "./point-order-detail-retail.vue?vue&type=template&id=246a2954"
import script from "./point-order-detail-retail.vue?vue&type=script&lang=js"
export * from "./point-order-detail-retail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports